// removed by extract-text-webpack-plugin
module.exports = {"miniChart":"antd-pro_-_-scaffold-src-components-Charts-miniChart"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/index.less
// module id = 137
// module chunks = 0 1